const constants = Object.freeze({
  WEEKDAYS: { SUN: 1, MON: 2, TUE: 3, WED: 4, THU: 5, FRI: 6, SAT: 7 },

  //IANA Unix TZ names used in Luxon DateTime converted to time zone names
  TIME_ZONES: {
    //Newfoundland. Standard: -03:30, DST: -02:30
    "America/St_Johns": "Newfoundland Time", //Newfoundland and Labrador
    //Atlantic. Standard: -04:00, DST: -03:00
    "America/Goose_Bay": "Atlantic Time", //Most of east Labrador: Happy Valley-Goose Bay
    "America/Halifax": "Atlantic Time", //West Labrador, Nova Scotia, Prince Edward Island
    "America/Moncton": "Atlantic Time", //New Brunswick
    "America/Glace_Bay": "Atlantic Time", //Nova Scotia
    "America/Blanc-Sablon": "Atlantic Time", //Quebec
    //Eastern. Standard: -05:00, DST: -04:00
    "America/Montreal": "Eastern Time", //Quebec
    "America/Toronto": "Eastern Time", //Ontario
    "America/Thunder_Bay": "Eastern Time", //Ontario
    "America/Nipigon": "Eastern Time", //Ontario
    "America/Pangnirtung": "Eastern Time", //Nunavut
    "America/Atikokan": "Eastern Time", //Ontario
    "America/Iqaluit": "Eastern Time", //Nunavut
    "America/Coral_Harbour": "Eastern Time", //Nunavut
    //Central. Standard: -06:00, DST: -05:00
    "America/Rainy_River": "Central Time", //Ontario
    "America/Winnipeg": "Central Time", //Manitoba
    "America/Regina": "Central Time", //Saskatchewan
    "America/Swift_Current": "Central Time", //Saskatchewan
    "America/Resolute": "Central Time", //Nunavut
    "America/Rankin_Inlet": "Central Time", //Nunavut
    //Mountain. Standard: -07:00, DST: -06:00
    "America/Edmonton": "Mountain Time", //Alberta
    "America/Dawson_Creek": "Mountain Time", //British Columbia
    "America/Creston": "Mountain Time", //British Columbia
    "America/Fort_Nelson": "Mountain Time", //British Columbia
    "America/Cambridge_Bay": "Mountain Time", //Nunavut
    "America/Yellowknife": "Mountain Time", //Northwest Territories
    "America/Inuvik": "Mountain Time", //Northwest Territories
    //Pacific. Standard: -08:00, DST: -07:00
    "America/Vancouver": "Pacific Time", //British Columbia
    "America/Whitehorse": "Pacific Time", //Yukon
    "America/Dawson": "Pacific Time", //Yukon
  },

  REQUEST_TYPES: {
    INQUIRY: 1,
    CONSULT: 2,
  },

  STEPS: {
    LAW: "Law",
    TYPE: "Type",
    ADDRESS: "Address",
    BOOKING: "Booking",
    DETAILS: "Details",
  },

  LAWS: {
    PI: "Personal Injury",
    WILLS: "Wills & Estates",
    RE: "Real Estate",
    EMPLOYMENT: "Employment",
    OTHER: "Other",
    UNSURE: "I'm not sure",
  },

  MEETING_TYPES: {
    NOT_SELECTED: 0,
    IN_PERSON: 1,
    VIRTUAL: 2,
    PHONE: 3,
  },

  BOOKING_STATUS: {
    FLOW: 1,
    PRE_QUALIFIED: 2,
    QUALIFYING: 3,
    QUALIFIED: 4,
    NOT_QUALIFIED: 5,
    EXTRA_OCCUPANTS: 6,
    EXTRA_OCCUPANTS_QUALIFIED: 7,
    COMPLETE: 8,
    COMPLETE_EXTRA_OCCUPANTS: 9,
  },

  LITCO_NUMBER: "1-844-Litco4U",

  TIME_SIMPLE: { hour: "numeric", minute: "2-digit", hourCycle: "h12" },
});

export default constants;

export const constant_names = Object.freeze({
  MEETING_TYPE_NAMES: {
    [constants.MEETING_TYPES.NOT_SELECTED]: "Not Selected",
    [constants.MEETING_TYPES.IN_PERSON]: "In-Person",
    [constants.MEETING_TYPES.VIRTUAL]: "Virtual",
    [constants.MEETING_TYPES.PHONE]: "Phone",
  },

  WEEKDAYS_NAMES: {
    [constants.WEEKDAYS.SUN]: "Sun",
    [constants.WEEKDAYS.MON]: "Mon",
    [constants.WEEKDAYS.TUE]: "Tue",
    [constants.WEEKDAYS.WED]: "Wed",
    [constants.WEEKDAYS.THU]: "Thu",
    [constants.WEEKDAYS.FRI]: "Fri",
    [constants.WEEKDAYS.SAT]: "Sat",
  },

  REQUEST_TYPE_NAMES: {
    [constants.REQUEST_TYPES.INQUIRY]: "Inquiry",
    [constants.REQUEST_TYPES.CONSULT]: "Consult",
  },
});

export const FLOW = Object.freeze({
  // [constants.REQUEST_TYPES.INQUIRY]: [STEPS.LAW, STEPS.TYPE, STEPS.ADDRESS, STEPS.BOOKING, STEPS.DETAILS],
  [constants.REQUEST_TYPES.INQUIRY]: [constants.STEPS.LAW, constants.STEPS.BOOKING, constants.STEPS.DETAILS],
  [constants.REQUEST_TYPES.CONSULT]: [
    constants.STEPS.TYPE,
    constants.STEPS.ADDRESS,
    constants.STEPS.BOOKING,
    constants.STEPS.DETAILS,
  ],
});

//Google Analytics page tags
export const GA_STEP = Object.freeze({
  Qualifying: "00",
  [constants.STEPS.LAW]: "01",
  [constants.STEPS.TYPE]: "02",
  [constants.STEPS.ADDRESS]: "03",
  [constants.STEPS.BOOKING]: "04",
  [constants.STEPS.DETAILS]: "05",
  "Extra Occupants": "06",
  "Complete": "07",
  "Not Qualified": "08",
});
